import { Link, useLocation } from 'react-router-dom'
import MockDataBanner from '../finance/MockDataBanner'

const TABS = [
  { path: '/dashboard/financial-app', label: 'Overview', icon: '📊', end: true },
  { path: '/dashboard/financial-app/screener', label: 'Screener', icon: '🔎', end: false },
  { path: '/dashboard/financial-app/markers', label: 'Marker Lab', icon: '🧪', end: false },
  { path: '/dashboard/financial-app/convertibles', label: 'Convertibles', icon: '⚖️', end: false },
  { path: '/dashboard/financial-app/montecarlo', label: 'Monte Carlo', icon: '🎲', end: false },
  { path: '/dashboard/financial-app/ideas', label: 'Ideas', icon: '💡', end: false },
  { path: '/dashboard/financial-app/filings', label: 'Filings', icon: '📄', end: false },
  { path: '/dashboard/financial-app/research', label: 'Opus Research', icon: '🧠', end: false },
]

/**
 * Shared frame for every Securities Research page: suite header, sub-navigation
 * tabs, and the sample-data banner.
 */
export default function ResearchShell({
  showMockBanner,
  children,
}: {
  showMockBanner: boolean
  children: React.ReactNode
}) {
  const location = useLocation()

  return (
    <div>
      {/* Header */}
      <div className="flex items-center gap-3 mb-4">
        <Link
          to="/dashboard"
          className="text-slate-500 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white transition-colors"
        >
          <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </Link>
        <span className="text-3xl">📊</span>
        <div>
          <h1 className="text-2xl font-bold text-slate-900 dark:text-white">Securities Research</h1>
          <p className="text-slate-500 dark:text-slate-400 text-sm">
            Screeners, idea tracking, filings, and Opus-powered analysis
          </p>
        </div>
      </div>

      {/* Suite navigation */}
      <div className="flex gap-1 mb-6 overflow-x-auto pb-1 -mx-1 px-1">
        {TABS.map((t) => {
          const active = t.end
            ? location.pathname === t.path
            : location.pathname.startsWith(t.path)
          return (
            <Link
              key={t.path}
              to={t.path}
              className={`px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-colors ${
                active
                  ? 'bg-slate-200 dark:bg-slate-700 text-slate-900 dark:text-white'
                  : 'text-slate-500 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white hover:bg-slate-200/50 dark:hover:bg-slate-700/50'
              }`}
            >
              <span className="mr-1.5">{t.icon}</span>
              {t.label}
            </Link>
          )
        })}
      </div>

      <MockDataBanner visible={showMockBanner} />

      {children}
    </div>
  )
}
